/**
 * Web entry — avoid GestureHandlerRootView; it can block Pressable clicks on web.
 */
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { WebAppShell } from './src/components/layout/WebAppShell.web';
import { RootNavigator } from './src/core/navigation/RootNavigator';
import { AppProviders } from './src/core/providers/AppProviders';

function hideBootSplash() {
  const el = document.getElementById('boot-splash');
  if (!el) return;
  el.classList.add('boot-splash-hide');
  window.setTimeout(() => el.remove(), 280);
}

function App() {
  useEffect(() => {
    hideBootSplash();
  }, []);
  return (
    <View style={styles.root}>
      <SafeAreaProvider>
        <AppProviders>
          <WebAppShell>
            <RootNavigator />
          </WebAppShell>
        </AppProviders>
      </SafeAreaProvider>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    minHeight: 0,
    height: '100%',
    width: '100%',
  },
});

export default App;
